import React from "react";
import "./Stages.css";

interface CircularProgressProps {
  progress: any; // Percentage of progress (0-100)
  completedSize: number; // Size completed in MB
  totalSize: number; // Total size in MB
  stage: any; // Size of the circular progress (default: 200px)
}

const stageMap = ["Uploading", "Analyzing", "Implementing", "Delivery"];

const ProgressStages: React.FC<CircularProgressProps> = ({
  progress,
  completedSize,
  totalSize,
  stage,
}) => {
  const strokeWidth = 10;
  const radius = (200 - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;
  console.log("Stage Mapped", stageMap[stage], stage)
  return (
    <div className="stage-container">
      <div className="circular-progress-container">
        <svg
          className="progress-ring"
          width={200}
          height={200}
          viewBox={`0 0 ${200} ${200}`}
        >
          <circle
            className="progress-ring-background"
            cx={200 / 2}
            cy={200 / 2}
            r={radius}
            strokeWidth={strokeWidth}
          />
          <circle
            className="progress-ring-circle"
            cx={200 / 2}
            cy={200 / 2}
            r={radius}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        <div className="progress-text">
          <p className="progress-percentage">{`${progress}%`}</p>
          {stage === 0 && (
            <p className="progress-size">{`${completedSize}MB / ${totalSize}MB`}</p>
          )}
        </div>
        <p className="progress-status">{stageMap[stage]} in progress</p>
      </div>
      <div className="stage-name-container">
        {stageMap.map((item, index) => {
          return (
            <div className={index === stage ? "current-stage" : ""} key={index}>
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressStages;
